import React, { useEffect, useState } from "react";
import FilterRadioButtons from "../../forms/filter-radio-buttons";
import { RolesListAction } from "../../../redux/actions/general-action";
import { useDispatch } from "react-redux";

const UserFilter = ({ setFilterData, filterData, setCurrentPage }) => {
  const [rolesList, setRolesList] = useState([]);
  const dispatch = useDispatch();
  const handleRoleChange = (e) => {
    setFilterData({
      ...filterData,
      role: e.target.value,
    });
    setCurrentPage(1);
  };

  useEffect(() => {
    dispatch(RolesListAction(onSuccessRoles, onErrorRoles));
  }, []);
  const onSuccessRoles = (data) => {
    setRolesList(
      data?.data?.map((item) => ({
        label: item?.role_name,
        value: item?.role_name,
      }))
    );
  };
  const onErrorRoles = (data) => {};

  return (
    <div
      menuPortalTarget={document.body}
      style={{
        minWidth: "17rem",
        zIndex: 999,
        top: "40px",
        right: "-5px",
        boxShadow: `0 12px 32px -8px var(--popover-shadow-color), 0 2px 6px -2px var(--popover-shadow-color)`,
      }}
      className="absolute  border border-[var(--popover-border-color)] border-solid border-1   py-3 px-2  bg-[var(--popover-bg-color)]  rounded-xl z-10 flex flex-col"
    >
      <span className="px-3 pt-1.5 pb-2.5 text-sm fw_600 text-[var(--popover-heading-fg-color)]">
        Filter by
      </span>
      <hr className="border-0 border-t border-[var(--popover-border-color)] -mx-2" />
      <div>
        <FilterRadioButtons
          name="role"
          label={"Filter Roles"}
          options={rolesList}
          handleChange={handleRoleChange}
          value={filterData?.role}
        />
      </div>
    </div>
  );
};

export default UserFilter;
